var developer = new function(){

  var me = this;

  this.preventHashChange = false;
  this.allowHashChange = false;

  this.loader = {
    "show": function(){
      $(".invest__image-loader").css('display','block');
    },
    "hide": function(){
      $(".invest__image-loader").css('display','none');
    }
  };

  this.filter = {
    "operators": {
      "rooms": ">=",
      "floor": "=",
      "size_from": ">=",
      "size_to": "<="
    },
    "fields": {
      "rooms": "rooms",
      "floor": "floor",
      "size_from": "size",
      "size_to": "size"
    },
    "list": function(){
      var emptyCounter = 0, queryString = "";
      var filters = [];
      $("[data-developer-filter-container] tr").fadeOut().promise().done(function(){
        for(var i=0;i<$("[data-developer-filter]").length;i++){
          var el = $("[data-developer-filter]").eq(i);
          var filterName = el.attr('data-developer-filter');
          var tagName = el.prop('tagName').toLowerCase();
          if(tagName == "select")
            var value = $("[data-developer-filter='"+filterName+"'] option:selected").val();
          else
            var value = $("[data-developer-filter='"+filterName+"']").val();

          if(value!=""){
            filters[filterName] = parseFloat(value);
          }else{
            emptyCounter++;
          }
        }
        if(emptyCounter == $("[data-developer-filter]").length){
          me.filter.empty = true;
          $("[data-developer-filter-container] tr").fadeIn();
        }else{
          var show = true,field,operator,value;
          for(var j=0;j<$("[data-developer-filter-container] tr").length;j++){
              el = $("[data-developer-filter-container] tr").eq(j);
              show = true;
              for(var filter in filters){
                field = me.filter.fields[filter];
                value = parseFloat(el.attr('data-'+field));
                operator = me.filter.operators[filter];

                if(operator=="=" && parseFloat(value)!=parseFloat(filters[filter])){
                  show = false;
                }else if(operator=="<=" && value>parseFloat(filters[filter])){
                  show = false;
                }else if(operator==">=" && value<parseFloat(filters[filter])){
                  show = false;
                }
              }
              if(show){
                el.fadeIn();
              }
          }
        }

      });
    },
    "offertype": function(value){
      if(value=="" || value==0){
        $("[data-investment-id]").each(function(i,el){
          $(el).fadeIn();
        });
      }else{
        $.post('/developer/offertype',{'type_id':parseInt(value),'_token': window.Laravel.csrfToken},function(response){
          $("[data-investment-id]").each(function(i,el){
            if($.inArray(parseInt($(el).attr('data-investment-id')),response)==-1){
              $(el).fadeOut();
            }else{
              $(el).fadeIn();
            }
          });
        },"json");
      }
    }
  };

  this.calculator = {
    "params": {},
    "calculate": function(formIndex){
      var empty = false;
      var elements = $("[data-developer-rentform]").eq(formIndex).find("[data-developer-sidebar-calculator]");
      for(var i=0; i< elements.length; i++){
        var el = elements.eq(i);
        var tagName = el.prop('tagName').toLowerCase();
        if(tagName == "select")
          var value = el.find("option:selected").val();
        else
          var value = el.val();
        if(value=="")
          empty = true;
        me.calculator.params[el.attr('data-developer-sidebar-calculator')] = value;
      }
      if(!empty)
        me.calculator.request(formIndex);
    },
    "request": function(formIndex){
      me.calculator.params._token = window.Laravel.csrfToken;
      $.post('/developer/calcrent',me.calculator.params,function(response){
        var form = $("[data-developer-rentform]").eq(formIndex);
        form.find("[data-developer-rent]").val(response.rent + " zł");
        form.find("[data-developer-advance]").val(response.advance+ " zł");
      },"json");
    },
    "bindEvents": function(){
      var changeInputFunction = function(el){
        var form = $("body").find("[data-developer-rentform]");
        console.log(form.length);
        for(var i=0;i<form.length;i++){
          if(form[i].checkValidity())
            me.calculator.calculate(i);
          else{
            validatedInput = el;
            setTimeout(function(){
              validatedInput.closest('[data-developer-rentform]')[i].reportValidity();
            },1);
          }
        }
      };
      $("[data-developer-sidebar-calculator]").bind('change',function(){
        changeInputFunction($(this));
      });
      $("[data-developer-sidebar-calculator]").bind('blur',function(){
        changeInputFunction($(this));
      });
    }
  };

  this.menu = {
    "building": "",
    "floor": "",
    "redirectedAfterBack": false,
    "canChange": true,
    "history":true,
    "fromTrigger": false,
    "request": function(params,callback){
      params._token = window.Laravel.csrfToken;
      me.layer.unbindHover();
      $('.js-invest__tooltip').removeClass('tooltip--visible');
      $.post('/developer/getlayers',params,function(response){
        switch(params['type']){
          case 'building':
            me.menu.floor = "";
            break;
        }
        me.menu[params['type']] = params['id'];
        $("#image-map area").remove();
        if(response.img!=""){
          var oldImage = document.getElementById('image');
          var newImage = new Image();
          newImage.onload = function(){
              //oldImage.src = response.img;

              $(".invest img").attr('src',response.img+'?v='+response.hash);
              me.loader.hide();
              callback();

              setTimeout(function(){
                var html = "",layer;
                for(var i=0; i<response.layers.length;i++){
                  layer = response.layers[i];
                  html = "<area target alt title data-id='"+layer.destination_id+"' data-menu='"+response.menu+"'";
                  html+= " data-width='"+layer.width+"' data-height='"+layer.height+"' data-default='"+layer.coords+"'";
                  html+= " coords='"+layer.coords+"' shape='"+layer.shape+"' data-point='"+layer.point+"'";
                  if(typeof response.tooltip[layer.id] !== "undefined"){
                    html+= " data-tooltip-title='"+response.tooltip[layer.id].title+"'";
                    html+= " data-tooltip-content='"+response.tooltip[layer.id].content+"'";
                  }
                  html+= " data-coords='"+layer.coords+"'/>"
                  $("#image-map").append(html);
                  //s$('.image-map area').attr('href','#' + me.menu.building+','+me.menu.floor);
                }
                $("#image-map area").css('cursor','pointer');

                $(window).trigger('resize');
                //me.layer.bindHover();

                // if(hrefParams.length>1 && me.menu.redirectedAfterBack==false){
                //   var a = "[data-developersubmenu='"+hrefParams[0]+"'] li a[data-id='"+hrefParams[1]+"']";
                //   if($(a).length==1){
                //     me.allowHashChange = true;
                //     $(a).trigger('click');
                //   }
                //   me.menu.redirectedAfterBack = true;
                // }

                // console.log('fromTrigger ' + me.menu.fromTrigger);
              },500);
          };
          newImage.src = response.img+'?v='+response.hash;

        }else{
          me.loader.hide();
          callback();
        }
      },"json").error(function(){
        callback();
        me.loader.hide();
      });
    },
    "urlChange": function(){
      /**
       * HISTORY
       */
      hrefParams = [];
      var hrefParts = top.location.href.split('#');

      // console.log('urlChange');
      // console.log(top.location.href);

      if(hrefParts.length>1){
        hrefParams = hrefParts[1].split(',');
        if(hrefParams.length>0)
          me.menu.building = hrefParams[0];
        else
          me.memu.building = "";
        if(hrefParams.length>1 && hrefParams[1]!="")
          me.menu.floor = hrefParams[1];
        else
          me.menu.floor = "";

        // console.log('building ' + me.menu.building);
        // console.log('floor ' + me.menu.floor);

        if(me.menu.floor=="")
          var a = "[data-developermenu] li a[data-id='"+hrefParams[0]+"']";
        else
          var a = "[data-developersubmenu='"+hrefParams[0]+"'] li a[data-id='"+hrefParams[1]+"']";

        if($(a).length == 1){
            me.menu.canChange = false;
            $(a).trigger('click');
            me.menu.canChange = true;
        }
    }else{
      var a = "[data-developersubmenu='"+me.menu.building+"'] a[data-id='0']";
      if($(a).length == 1){
        me.menu.fromTrigger = true;
        $(a).trigger('click');
        me.menu.fromTrigger = false;
      }
    }

      // me.menu.firstChange = false;
    },
    "bindEvents": function(){
      $("[data-developermenu] a").bind('click',function(){
        var id = $(this).attr('data-id');
        buildingId = id;
        me.loader.show();

        var params = {
          'type': 'building',
          'id': parseInt(id)
        };

        if($("[data-developermenu]").is(':visible')){
          $("[data-developermenu]").slideUp('slow',function(){
              me.menu.request(params,function(){
                  $("[data-developersubmenu='"+id+"']").slideDown('slow');
                  $(".invest__list-text").html("lista kondygnacji");
                  $("[data-building-id]").not("[data-building-id='"+id+"']").fadeOut();
              });
          });
        }else{
          // console.log('developermenu invisible');
          $("[data-developermenu] [data-id='"+id+"']").closest('ul').css({'display':'none'});
          me.menu.request(params,function(){
              $("[data-developersubmenu='"+id+"']").css({'display':'block'});
              $(".invest__list-text").html("lista kondygnacji");
              $("[data-building-id]").not("[data-building-id='"+id+"']").css({'display':'none'});
          });
        }

        me.menu.building = id;

        /**
         * HISTORY
         */
        // console.log('menu click - 289');
        if(me.menu.history){
          me.menu.canChange = false;
          var hrefParts = top.location.href.split('#');
          top.location.href = hrefParts[0] + "#" + id;
          me.menu.canChange = true;
        }

      });

      $("[data-developersubmenu] a").bind('click',function(){
        me.preventHashChange = true;
        me.loader.show();
        currentA = $(this);
        var id = parseInt(currentA.attr('data-id'));
        titleA = currentA.attr('data-text');
        if(id == 0){
          var active = $("[data-developersubmenu] li.active").length;
          // console.log('active submenu ' + active);
          if(active){
            var params = {
              'type': 'building',
              'id': parseInt($(this).closest("ul").attr('data-developersubmenu'))
            };
          }else{
            var params = {
              'type': 'investment',
              'id': parseInt($("[data-developermenu]").attr('data-developermenu'))
            };
          }
          me.menu.request(params,function(){
            // console.log('submenu request');
            if(active){
              $("[data-developersubmenu] li.active").removeClass('active');
              $("[data-developer-subtitle]").html("");
              $("[data-floor-id]").fadeIn();
            }else{
              $("[data-developer-subtitle]").html("");
              $("[data-developersubmenu] li.active").removeClass("active");
              $("[data-developersubmenu='"+buildingId+"']").slideUp('slow',function(){
                $("[data-developermenu]").slideDown('slow');
                $(".invest__list-text").html("lista budynków");
                $("[data-building-id]").fadeIn();
                $("[data-floor-id]").fadeIn();
              });
            }
          });

          // console.log('wróc click 520');

          if(me.menu.history){
            if(me.menu.floor==""){
              // console.log('wroc if');
              me.menu.building = "";
              history.replaceState(null, null, ' ');
            }else{
              // console.log('wroc else');
            }
            me.menu.floor = "";
          }
        }else{
          var params = {
            'type': 'floor',
            'id': id
          };
          me.menu.request(params,function(){
            $("[data-developer-subtitle]").html(", "+titleA);
            $("[data-developersubmenu] li.active").removeClass("active");
            currentA.closest('li').addClass('active');
            $("[data-floor-id]").fadeIn().promise().done(function(){
              $("[data-floor-id]").not("[data-floor-id='"+id+"']").fadeOut();
            });
          });
          me.menu.floor = id;
        }

        /**
         * HISTORY
         */
        // console.log('submenu click 348');
        if(me.menu.history){
          me.menu.canChange = false;
          var hrefParts = top.location.href.split('#');

          // console.log('building ' + me.menu.building);
          // console.log('floor ' + me.menu.floor);

          if(me.menu.building==0) me.menu.building = "";

          if(me.menu.building == ""){
            if(hrefParts.length>1){
              history.replaceState(null, null, ' ');
            }
          }else if(me.menu.floor == "" || me.menu.floor==0){
            top.location.href = hrefParts[0] + "#" + me.menu.building;
          }else{
            top.location.href = hrefParts[0] + "#" + me.menu.building + "," + me.menu.floor;
          }
          me.menu.canChange = true;
        }
      });
    }
  };

  this.mail = {
    "recommend": function(){
      var el = $('[data-developer-recommendapartment]').closest('form');
      var params = {
        'sender': el.find('input[name="sender"]').val(),
        'email': el.find('input[name="email"]').val(),
        'investment_id': el.find('input[name="investmentid"]').val(),
        'investment': el.find('input[name="investment"]').val(),
        'apartment': el.find('input[name="apartment"]').val(),
        'apartment_id': el.find('input[name="apartmentid"]').val(),
        '_token': window.Laravel.csrfToken
      };
      $.post('/developer/recommendapartment',params,function(response){
        var el = $('[data-developer-recommendapartment]').closest('form');
        if(parseInt(response.code)==1){
          el.find('input[name="sender"]').val('');
          el.find('input[name="email"]').val('');
          el.find('input[type="checkbox"]').prop('checked',false);
          $('[data-developerform-message]').attr('class','success').html('Wiadomość została wysłana');
        }else{
          $('[data-developerform-message]').attr('class','error').html('Wiadomość nie została wysłana');
        }
      },"json");
    },
    'bindEvents': function(){
      $('[data-developer-recommendapartment]').bind('click',function(){
        if ($(this).closest('form')[0].checkValidity() === true) {
          $("[data-developerform-message]").attr('class','').html('');
          me.mail.recommend();
        }else{
          $("[data-developerform-message]").attr('class','error').html('Uzupełnij poprawnie wszystkie pola');
        }
      });
    }
  };

  this.layer = {
    firstRun: true,
    click: function(el){
      var id = el.attr('data-id');
      var menu = el.attr('data-menu');
      if(menu == 'apartment'){
          var href = $("tr[data-apartment-id='"+id+"']").attr('data-href');
          var status = $("tr[data-apartment-id='"+id+"']").attr('data-status');
          if(typeof href !== "undefined" || (typeof status!=="undefined" && status!="red"))
            top.location.href = href;
      }else{
        me.menu.fromTrigger = true;
        $('['+menu+']').find('li a[data-id="'+id+'"]').trigger('click');
        me.menu.fromTrigger = false;
      }
    },
    bindHover: function(){
      var color = $("[data-developer-color]").attr('data-developer-color');
      if(typeof color !== "undefined"){
        color = color.substring(1);
        $('img.js-image-map').maphilight({
        	'fillColor': color,
        	'strokeColor': color
        });
      }
    },
    unbindHover: function(){
      $("img.js-image-map").detach().insertAfter(".invest__image-loader");
      $("div.js-image-map").remove();
      $("map").unbind('alwaysOn.maphilight mouseover.maphilight focusin.maphilight');
      $("img.js-image-map").unbind('alwaysOn.maphilight mouseover.maphilight focusin.maphilight');
      $("img.js-image-map").removeClass('maphilighted').removeAttr('style');
    },
    resize: function(resolve){
      var newImage = new Image();
      newImage.onload = function(){
        var imageWidth = $("img.js-image-map").outerWidth();
        var imageHeight = $("img.js-image-map").outerHeight();

        //console.log("image " + imageWidth + ' ' + imageHeight);

        var widthPercent,heightPercent,coords,el,shape,x,y,point,temp,layerWidth,layerHeight;
        var areas = $('#image-map area'),newCoords="";

        for(var i=0; i<areas.length;i++){
            el = areas.eq(i);
            newCoords = "";
            coords = areas.eq(i).attr('data-default').split(',');
            widthPercent = parseFloat(el.attr('data-width'))/100;
            heightPercent = parseFloat(el.attr('data-height'))/100;

            //console.log("coords: " + coords);
            //console.log("widthPercent " + widthPercent);
            //console.log("heightPercent " + heightPercent);

            shape = el.attr('shape')

            point = el.attr('data-point').split(',');

            //console.log("point " + point);

            x = (parseFloat(point[0])/100)*imageWidth;
            y = (parseFloat(point[1])/100)*imageHeight;

            //console.log("y " + y);

            layerWidth = imageWidth*widthPercent;
            layerHeight = imageHeight*heightPercent;

            //console.log("layerHeight " + layerHeight);

            if(shape == 'rect'){
              newCoords = x + ','
                        + y + ','
                        + (x + imageWidth*widthPercent) + ','
                        + (y + imageHeight*heightPercent);
            }else if(shape == 'poly'){
              temp = [];

              for(var j=0; j < coords.length; j++){
                if(j%2 == 0){
                  temp.push(parseFloat(x) + ((parseFloat(coords[j])/100) * layerWidth));
                }else{
                  ///console.log("for");
                  //console.log(parseFloat(y));
                  //console.log(parseFloat(coords[j])/100);
                  //console.log((parseFloat(coords[j])/100) * layerHeight);
                  temp.push(parseFloat(y) + ((parseFloat(coords[j])/100) * layerHeight));
                }
              }
              newCoords = temp.join(',');
            }

            el.attr('data-coords',newCoords);
            el.attr('coords',newCoords);
        }
      };
      if($("img.js-image-map").length == 1)
        newImage.src = $("img.js-image-map").attr('src');
    },
    bindEvents: function(){
      $(window).bind('resize',function(){
        //setTimeout(function(){
          me.layer.unbindHover();
          developer.layer.resize();
          me.layer.bindHover();
        //});
      });

      $(window).trigger('resize');

      $("#image-map").on('click','area',function(){
        me.layer.click($(this));

        // console.log('map area click - 519');
        /**
         * HISTORY
         */

        // if(me.menu.history){
        //   if(top.location.href.indexOf('#')!==-1){
        //     //me.preventHashChange = true;
        //     var hrefParts = top.location.href.split('#');
        //     var hrefParams = hrefParts[1].split(',');
        //     if(hrefParams.length<2 || (hrefParams.length==2 && hrefParams[1]==""))
        //       top.location.href = hrefParts[0] + "#" + hrefParams[0] + "," + $(this).attr('data-id');
        //   }else{
        //     top.location.href+= "#" + $(this).attr('data-id');
        //   }
        // }

      });
    }
  };

  this.bindEvents = function(){
    $("[data-developer-filter]").bind('change',function(){
      me.filter.list();
    });
    $("[data-developer-offerlistfilter]").bind('change',function(){
      var value = $(this).find('option:selected').val();
      me.filter.offertype(value);
    });

    me.calculator.bindEvents();
    me.menu.bindEvents();
    me.mail.bindEvents();
    me.layer.bindEvents();

    $("[data-developer-rentform]").submit(function(){
      $(this).trigger('change');
      return false;
    });
  };

};

$(document).ready(function(){
  developer.bindEvents();
  $('.image-map area').attr('href','#');

  $("[data-developer-back]").bind('click',function(){
    window.history.back();
  });

  var url = top.location.href;

  $(window).on('popstate', function(e){
    /**
     * HISTORY
     */
    if(developer.menu.history){
      if(developer.menu.canChange)
        developer.menu.urlChange();
    }

    if(!$(".invest__list").hasClass("invest__list--active")){
      if(developer.menu.building!="" && developer.menu.floor==""){
        $("[data-developersubmenu] li.active").removeClass("active");
      }
      if(developer.menu.building=="" && developer.menu.floor==""){
        $("[data-developersubmenu]").css('display','none');
      }
    }
  });

  developer.menu.urlChange();

});
